import styled from 'styled-components';

export const InputLoginStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateX(-20px);
  margin-bottom: 20px;

  img {
    width: 30px;
  }
`;

export const BoxInput = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  background-color: ${({ theme }) => {
    return theme.colors.primary;
  }};
  color: ${({ theme }) => {
    return theme.colors.white;
  }};
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};

  width: 400px;
  height: 60px;
  border-radius: ${({ theme }) => {
    return theme.borderRadius.normal;
  }};
  box-shadow: ${({ theme }) => {
    return theme.shadow;
  }};

  input {
    box-sizing: border-box;
    width: 320px;
    height: 40px;
    margin-left: 10px;
    border: ${({ theme }) => {
      return theme.border;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.white;
    }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    font-family: 'Ubuntu', sans-serif;
    color: ${({ theme }) => {
      return theme.colors.black;
    }};
    padding: 0 5px;

    input::placeholder {
      color: ${({ theme }) => {
        return theme.colors.border;
      }};
    }
  }
`;

export const PasswordIcon = styled.img`
  position: absolute;
  right: 5%;
  cursor: pointer;
`;
